import { OrganisationFeedItemDto } from '@careapp-group/ng-sdk';
import { CareAppListActionFactory } from '../action-factory';

export const Feed = new CareAppListActionFactory<OrganisationFeedItemDto>(`Feed`);
